import { StatusBadge } from '@treezor/design-system';

import { TKycDocumentStatus } from '@/features/kyc/store/models/kyc.model';
import { useKycDocuments } from '@/features/kyc/hooks/useKycDocuments';

interface IKycDocumentStatusProps {
  status: TKycDocumentStatus;
}

export function KycDocumentStatusLabel({ status }: IKycDocumentStatusProps) {
  const { documentStatusProps } = useKycDocuments();

  return <StatusBadge emphasis="low" {...documentStatusProps[status]} />;
}
